import React from 'react'
import PropTypes from 'prop-types'
import EmptyState from '../ui/EmptyState'
import Loader from '../shared/Loader'
import ToggleGroup from '../ui/ToggleGroup'
import AbsoluteChart from './AbsoluteChart'
import PercentChart from './PercentChart'
import Card from '../ui/Card'
import { bucketShape } from '../charts/config'

const DISPLAY_OPTIONS = [
  { value: 'absolute', label: 'Valeur absolue' },
  { value: 'percent', label: 'Pourcentage (%)' }
]

const EMPTY_MESSAGE = 'La progression de vos contrôles et alertes apparaîtra ici '
  + 'une fois les données disponibles.'

const LOADING_OVERLAY_CLASSES = 'tw:absolute tw:inset-0 tw:flex tw:items-center '
  + 'tw:justify-center tw:bg-white/70 tw:z-10'

const EMPTY_BUCKETS = []

const hasBucketData = buckets => buckets.some(bucket => Boolean(bucket?.count))
const hasSatisfactionData = buckets =>
  buckets.some(bucket => typeof bucket?.value === 'number')

const ControlsAlertsChart = ({
  alerts = EMPTY_BUCKETS,
  controls = EMPTY_BUCKETS,
  displayMode,
  hasAlertsConfigured,
  headerRight = null,
  isLoading = false,
  onDisplayModeChange,
  satisfaction = EMPTY_BUCKETS
}) => {
  const isPercent = displayMode === 'percent'

  const isEmpty = !hasBucketData(controls)
    && !hasBucketData(alerts)
    && !hasSatisfactionData(satisfaction)
  const showEmptyState = isEmpty && !isLoading

  const headerControls = isEmpty ? null : (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-2">
      {headerRight}
      <ToggleGroup
        ariaLabel="Mode d'affichage"
        options={DISPLAY_OPTIONS}
        value={displayMode}
        onChange={onDisplayModeChange}
      />
    </div>
  )

  return (
    <Card headerRight={headerControls} title="Contrôles et alertes" plainHeader>
      <div className="tw:relative">
        {showEmptyState ? <EmptyState message={EMPTY_MESSAGE} /> : null}
        {!showEmptyState && isPercent ? (
          <PercentChart
            alerts={alerts}
            controls={controls}
            hasAlertsConfigured={hasAlertsConfigured}
            satisfaction={satisfaction}
          />
        ) : null}
        {!showEmptyState && !isPercent ? (
          <AbsoluteChart
            alerts={alerts}
            controls={controls}
            hasAlertsConfigured={hasAlertsConfigured}
          />
        ) : null}
        {isLoading ? (
          <div className={LOADING_OVERLAY_CLASSES}>
            <Loader />
          </div>
        ) : null}
      </div>
    </Card>
  )
}

ControlsAlertsChart.propTypes = {
  alerts: PropTypes.arrayOf(bucketShape),
  controls: PropTypes.arrayOf(bucketShape),
  displayMode: PropTypes.oneOf(['absolute', 'percent']).isRequired,
  hasAlertsConfigured: PropTypes.bool.isRequired,
  headerRight: PropTypes.node,
  isLoading: PropTypes.bool,
  onDisplayModeChange: PropTypes.func.isRequired,
  satisfaction: PropTypes.arrayOf(bucketShape)
}

ControlsAlertsChart.defaultProps = {
  alerts: EMPTY_BUCKETS,
  controls: EMPTY_BUCKETS,
  headerRight: null,
  isLoading: false,
  satisfaction: EMPTY_BUCKETS
}

export default ControlsAlertsChart
